import { render, staticRenderFns } from "./UserViewAccountContent.vue?vue&type=template&id=1b2d5194&v-if=userData.content&"
import script from "./UserViewAccountContent.vue?vue&type=script&lang=js&"
export * from "./UserViewAccountContent.vue?vue&type=script&lang=js&"
import style0 from "./UserViewAccountContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports